import { render, staticRenderFns } from "./LucaComparationView.vue?vue&type=template&id=12479315&"
import script from "./LucaComparationView.vue?vue&type=script&lang=js&"
export * from "./LucaComparationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports